import { exportCsv } from 'src/graphql/exportCsv';

export const exportCsvHandler = async (csvMetaData) => {
  const csvChainId = csvMetaData?.csv_chain_id;
  const customMultiPromptId = csvMetaData?.customMultiPromptId;

  if (!csvChainId && !customMultiPromptId) {
    return;
  }

  const id = csvChainId ? { csvChainId } : { customMultiPromptId };

  const { downloadUrl } = await exportCsv(id);
  window.open(downloadUrl, '_blank');
};
